import { BFF_API_ROUTES } from '../../../../constants';
import { baseRTKApi } from '../../../shared/api/baseApi';

export const fetchBranches = baseRTKApi.injectEndpoints({
  endpoints: (build) => ({
    getBranches: build.query<any, any>({
      query: (body) => ({
        url: BFF_API_ROUTES.getBranches,
        method: 'GET',
        params: body,
      }),
      extraOptions: {
        maxRetries: 1,
        timeout: 15000,
      },
    }),
  }),
});

export const { useGetBranchesQuery } = fetchBranches;
